import React, { useEffect, useRef, useState } from 'react'
import '../../../../assets/css/s_recovery/overview/overview.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faPencil, faTrash, faStar } from '@fortawesome/free-solid-svg-icons';
import { Container, Row, Col, Modal, Form, Button, Table, Accordion, Badge } from 'react-bootstrap';
import { ReactComponent as EditIcon } from "../../../../assets/images/icon_svg/pen_w_line.svg";
import { ReactComponent as ClockIcon } from "../../../../assets/images/icon_svg/clock.svg";
import { ReactComponent as Reset } from "../../../../assets/images/icon_svg/reset.svg";
import { ReactComponent as Pieces } from "../../../../assets/images/icon_svg/pieces.svg";
import { ReactComponent as Eyeicon } from "../../../../assets/images/icon_svg/EyeIconGrey.svg";
import { ReactComponent as Linkicon } from "../../../../assets/images/icon_svg/Linkicon.svg";
import { ReactComponent as Unlinkicon } from "../../../../assets/images/icon_svg/unlinkicon.svg";
import { ReactComponent as Wcercle } from "../../../../assets/images/icon_svg/gray_circle.svg";
import { ReactComponent as OrangeClock } from "../../../../assets/images/icon_svg/orange_clock.svg";
import LightAddIcon from "../../../../assets/images/common/light_add_icon.png";
import { CommonModal } from '../../../../Components/common/CommonFunctions';
import { Remarks, RemarksForm } from '../../../../Components/common/Remarks';
import { CallApi } from "../../../../Components/common/CommonFunctions"
import { toast } from 'react-toastify';
import Popup from 'reactjs-popup';

const Overview = ({ propData, drpData, onReload, onEdit, onChangeDetails }) => {

  const [infoFormData, setInfoFormData] = useState({})
  const [openModal, setOpenModal] = useState(false)
  const [confModal, setConfModal] = useState(false)
  const [confData, setConfData] = useState({})
  const [editData, setEditData] = useState();

  const editClick = () => {
    onEdit()
  }
  const addRemarks = () => setOpenModal(true)
  const modalClose = () => setOpenModal(false)
  const confClose = () => setConfModal(false)

  useEffect(() => {
    // if (isMounted.current) return;
    setInfoFormData({

    })
    // isMounted.current = true;
  }, [propData]);

  const sendData = { id: propData.service_recovery_id, attType: 'airline_service_recovery' }

  const handleReload = () => {
    onReload()
    setOpenModal(false)
  }

  const linkUnlink = (data) => {
    setConfData(data)
    setConfModal(true)
  }
  const confLinkUnlink = () => {
    CallApi({
      endPoint: 'v2/service-recovery/link-another-recovery',
      payload: { service_recovery_id: propData?.service_recovery_id, ...confData },
      onSuccess: (res) => {
        if (res.data.response_code === 200) {
          toast.success(res.data.response_msg)
          onReload()
          confClose()
        } else {
          toast.error(res.data.response_msg)
        }

      },
      onError: (msg) => console.error(msg)
    });
  }



  return (
    <div className='d-flex justify-content-between'>
      <div className='tw-45 summary_card min-hgt-87'>
        <div className='info_card_title d-flex justify-content-between align-items-center'>
          <div className='info_title_wrap'>
            <h6>Shipment Information</h6>
            <p>Overview of key shipment details</p>
          </div>
          {!propData?.is_recovery_closed &&
            <Button variant='contained' className='edit_btn' onClick={editClick}>
              <EditIcon /> Edit
            </Button>
          }
        </div>
        <div className='summary_card_lftBg'>
          <div className='d-flex align-items-center justify-content-between'>
            <Form.Label className='summary_label'>AWB No.</Form.Label>
            <div className='summary_value txt_value'>
              {propData?.master_airway_bill_prefix}-{propData?.master_airway_bill_no}
            </div>
          </div>
          <div className='d-flex align-items-center justify-content-between'>
            <Form.Label className='summary_label'>Origin</Form.Label>
            <div className='summary_value txt_value'>
              {propData?.all_routing?.find(stn => stn.handler_type === 'Origin')?.station_code}
            </div>
          </div>
          <div className='d-flex align-items-center justify-content-between'>
            <Form.Label className='summary_label'>Destination</Form.Label>
            <div className='summary_value txt_value'>
              {propData?.all_routing?.find(stn => stn.handler_type === 'Destination')?.station_code}
            </div>
          </div>
          <div className='d-flex align-items-center justify-content-between'>
            <Form.Label className='summary_label'>Total Pieces</Form.Label>
            <div className='summary_value txt_value'>
              {propData?.total_pieces}
            </div>
          </div>
        </div>
        <div className='summary_card_lftBg'>
          <div className='d-flex align-items-center justify-content-between'>
            <Form.Label className='summary_label'>Irregularity Type</Form.Label>
            <div className='summary_value txt_value'>
              {propData?.irregularity_name?.join(', ')}
            </div>
          </div>
          <div className='d-flex align-items-center justify-content-between'>
            <Form.Label className='summary_label'>Pieces Involved</Form.Label>
            <div className='summary_value txt_value'>
              {propData?.pieces_involved}
            </div>
          </div>
          <div className='d-flex align-items-center justify-content-between'>
            <Form.Label className='summary_label'>Weight Involved</Form.Label>
            <div className='summary_value txt_value'>
              {propData?.weight_involved}
            </div>
          </div>
          <div className='d-flex align-items-center justify-content-between'>
            <Form.Label className='summary_label'>Flight No.</Form.Label>
            <div className='summary_value txt_value'>
              {propData?.flight_prefix}{propData?.flight_no}
            </div>
          </div>
          <div className='d-flex align-items-center justify-content-between'>
            <Form.Label className='summary_label'>Unit Details</Form.Label>
            <div className='summary_value txt_value'>
              {propData?.unit_details}
            </div>
          </div>
          <div className='d-flex align-items-center justify-content-between'>
            <Form.Label className='summary_label'>Additional Info</Form.Label>
            <div className='summary_value txt_value'>
              {propData?.additional_info}
            </div>
          </div>
          <div className='d-flex align-items-center justify-content-between'>
            <Form.Label className='summary_label'>Reported On</Form.Label>
            <div className='summary_value txt_value'>
              {propData?.created_date}
            </div>
          </div>
          <div className='d-flex align-items-center justify-content-between'>
            <Form.Label className='summary_label'>Reporting Station</Form.Label>
            <div className='summary_value txt_value'>
              {propData?.all_routing?.find(stn => stn.is_reported === 1)?.station_code}
            </div>
          </div>
        </div>
        <Accordion>
          <Accordion.Item eventKey="0">
            <Accordion.Header>Cargo Information</Accordion.Header>
            <Accordion.Body>
              <div className='summary_card_lftBg'>

                <div className='d-flex align-items-center justify-content-between'>
                  <Form.Label className='summary_label'>Nature of Goods</Form.Label>
                  <div className='summary_value txt_value'>
                    {propData?.nature_of_goods}
                  </div>
                </div>
                <div className='d-flex align-items-center justify-content-between'>
                  <Form.Label className='summary_label'>SHC</Form.Label>
                  <div className='summary_value txt_value'>
                    {propData?.shc_id?.join(', ')}
                  </div>
                </div>
                <div className='d-flex align-items-center justify-content-between'>
                  <Form.Label className='summary_label'>Freight Type</Form.Label>
                  <div className='summary_value txt_value'>
                    {propData?.freight_type_lable}
                  </div>
                </div>
                <div className='d-flex align-items-center justify-content-between'>
                  <Form.Label className='summary_label'>Product Code</Form.Label>
                  <div className='summary_value txt_value'>
                    {propData?.product_code}
                  </div>
                </div>

              </div>
            </Accordion.Body>
          </Accordion.Item>

        </Accordion>
        <Accordion>
          <Accordion.Item eventKey="1" className='mt-2'>
            <Accordion.Header>Parties Involved</Accordion.Header>
            <Accordion.Body>
              <div className='summary_card_lftBg'>

                <div className='d-flex align-items-center justify-content-between'>
                  <Form.Label className='summary_label'>Shipper</Form.Label>
                  <div className='summary_value txt_value'>
                    {propData?.shipper}
                  </div>
                </div>
                <div className='d-flex align-items-center justify-content-between'>
                  <Form.Label className='summary_label'>Consignee</Form.Label>
                  <div className='summary_value txt_value'>
                    {propData?.consignee}
                  </div>
                </div>
                <div className='d-flex align-items-center justify-content-between'>
                  <Form.Label className='summary_label'>Agent</Form.Label>
                  <div className='summary_value txt_value'>
                    {propData?.agent}
                  </div>
                </div>

              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
      <div className='tw-54'>
        {/* <div className='top_prt'>
          <div className='d-flex gap-3'>
            <div className='tw-33'>
              <div className='summary_card'>
                <ClockIcon className='icon' />
                <p>Case Age</p>
                <span className={`${propData?.age_class} d-flex align-items-center justify-content-center`}>
                  <OrangeClock /><span className='ps-1'>{propData?.age}</span>
                </span>
              </div>
            </div>
            <div className='tw-33'>
              <div className='summary_card'>
                <Pieces className='icon' />
                <p>Open / Closed</p>
                <span className={`${propData?.is_recovery_closed ? 'green_btn' : 'gray_btn'}`}>{propData?.is_recovery_closed ? 'Closed' : 'Open'}</span>
              </div>
            </div>
            <div className='tw-33'>
              <div className='summary_card'>
                <Reset className='icon' />
                <p>Last Update</p>
                <h5>{propData?.last_update}</h5>
              </div>
            </div>
          </div>
        </div> */}

        <div className='summary_card remarks_tab min-hgt-30 p-0'>
          <div className='info_card_title d-flex justify-content-between mb-0' style={{ padding: '9px 15px' }}>
            <div className='info_title_wrap'>
              <h6>Related Irregularities</h6>
              <p>Irregularities linked to this AWB</p>
            </div>
          </div>
          <div className='table-responsive'>
            <Table className='related_table'>
              <thead>
                <tr>
                  <th>Type</th>
                  <th>Status</th>
                  <th>Reported</th>
                  <th>Reported on</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {propData?.recovery_cases?.length > 0 ? (propData.recovery_cases.map((item, index) => (
                  <tr key={item.service_recovery_id ?? index}>
                    <td>
                      
                      <Popup
                        trigger={
                          <span className="">
                            {item.irregularity_type?.join(", ")}
                          </span>
                        }
                        className="poparrow"
                        position="bottom"
                        on={['hover', 'focus']}
                        arrow={true}
                      >
                        <div className='reco_toltrip'>

                          <h2>Recovery Case Details</h2>

                            <ul className="recovery_hover" >
                              <h4>RC-2025-00187</h4>
                              <li><span>Irregularity Type  </span> <span> {item.irregularity_type?.join(", ")} </span></li>
                              <li><span>Pieces Involved</span> <span>{item.pieces_involved} </span></li>
                              <li><span>Weight Involved </span> <span>{item.weight_involved}</span></li>
                              <li><span>Flight No.</span> <span>{item.flight_prefix}-{item.flight_no}</span></li>
                              <li><span>Unit Details </span> <span>{item.unit_details} </span></li>
                              <li><span>Assigned Region </span> <span>{item.assign_to}</span></li>
                              <li><span>Case Owner </span> <span> {item.region_name} </span></li>
                              <li><span>Last Update </span> <span>{item.reported_on}</span></li>
                            </ul>

                        </div>
                      </Popup>
                    </td>
                    <td>
                      <span
                        className={`${item.is_recovery_closed ? "green_btn" : "gray_btn"}`} > {item.is_recovery_closed ? "Closed" : "Open"}
                      </span>
                    </td>
                    <td>{item.reporting_station}</td>
                    <td>{item.reported_on}</td>
                    <td>
                      {item.service_recovery_id === propData?.service_recovery_id ? (
                        <label className='current_case'> <Wcercle /> Current Case</label>
                      ) : (
                        <>
                          <Button variant="link" onClick={() => onChangeDetails(item.service_recovery_id)} className='me-2'>
                            <Eyeicon width={14} height={14} />
                          </Button>
                          <Button variant="link" className={item.is_link === 1 ? 'greenlink' : 'hovergreen'} onClick={() => linkUnlink({ child_recovery_id: item.service_recovery_id, action: item.is_link === 1 ? 0 : 1 })}>
                            {item.is_link === 1 ? <Unlinkicon width={14} height={14} /> : <Linkicon width={14} height={14} />}
                          </Button>
                        </>
                      )
                      }
                    </td>
                  </tr>
                ))
                ) : (
                  <tr>
                    <td colSpan="5" className="px-2 pt-4 text-center no_item_text">
                      No related irregularities
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>

          </div>

        </div>

        <div className='summary_card remarks_tab min-hgt-56'>
          <div className='info_card_title d-flex justify-content-between'>
            <div className='info_title_wrap'>
              <h6>Remarks</h6>
              <p>Add and manage case notes</p>
            </div>
          </div>
          <div className='d-flex align-items-center gap-3'>
            <button className='create_btn' onClick={addRemarks}><img src={LightAddIcon} />Add Remark</button>
            <div className='remark_count'>
              <span className='rmks_cunt'>{propData?.activities?.comments?.length}</span>
              <span>Remarks</span>
            </div>

          </div>
          {propData?.activities?.comments?.length > 0 &&
            <div className='rmrks_dv max-hgt-45'>
              <Remarks propData={propData.activities} onReload={handleReload} onEdit={(e) => { setEditData(e); setOpenModal(true) }} />
            </div>
          }
        </div>
      </div>

      <CommonModal
        show={openModal}
        onHide={modalClose}
        title={'New Remark - ' + propData?.master_airway_bill_prefix + '-' + propData?.master_airway_bill_no}
        subTitle='Add a new remark to the recovery case.'
        className='modal_bgw primary_modal'
        footer={
          <div className='d-flex'>
            {/* <Button variant="secondary" onClick={modalClose}> Discard </Button>
            <Button variant="primary" onClick={handleSave} className="ms-auto"> Save </Button> */}
          </div>
        }>
        <RemarksForm propInfo={sendData} eData={editData} onReload={() => { handleReload(); setEditData() }} isModal={true} />
      </CommonModal>

      <CommonModal
        show={confModal}
        onHide={confClose}
        title={`${confData?.action === 1 ? 'Link' : 'Unlink'} irregularity case?`}
        // subTitle='Add a new remark to the recovery case.'
        className='modal_bgw primary_modal'
        footer={
          <div className='d-flex justify-content-between'>
            <Button variant="secondary" onClick={confClose}> Cancel </Button>
            <Button variant="primary" onClick={confLinkUnlink} className="ms-auto"> {confData?.action === 1 ? 'Link' : 'Unlink'} Case </Button>
          </div>
        }>
        <p>Remarks and attachments {confData?.action === 1 ? 'will be shared' : 'will not be shared'} between linked cases.</p>
      </CommonModal>
    </div>
  )
}

export default Overview